<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-right">
          <el-select
            v-model="workUserId"
            placeholder="请选择手艺人"
            size="small"
          >
            <el-option
              v-for="item in baseCrasftmanList"
              :key="item.workUserId"
              :label="item.nickName"
              :value="item.workUserId"
            ></el-option>
          </el-select>
          <el-input
            placeholder="请输入员工名称"
            v-model.trim="nickName"
            class="input-search"
            size="small"
            @keyup.enter.native="findSchedulingRecordList"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="findSchedulingRecordList"
            ></el-button>
          </el-input>
        </div>
      </div>
      <div class="tab-content" v-loading="isLoading">
        <div class="calendar">
          <div class="calendar-header">
            <el-button type="button" size="small" @click="batchEdit"
              >批量排班</el-button
            >
            <div class="date-ctrl">
              <div class="arrow" @click="changeMonth('reduce')">
                <svg
                  width="9"
                  height="14"
                  xmlns="http://www.w3.org/2000/svg"
                  class="zb-pagination-arrow"
                >
                  <path
                    d="M8 1L1.78 7 8 13"
                    stroke-width="2"
                    fill="none"
                    fill-rule="evenodd"
                  ></path>
                </svg>
              </div>
              <div class="date">
                {{ date.pattern("yyyy") }}年 {{ date.pattern("MM") }}月
              </div>
              <div class="arrow" @click="changeMonth('add')">
                <svg
                  width="9"
                  height="14"
                  xmlns="http://www.w3.org/2000/svg"
                  class="zb-pagination-arrow"
                >
                  <path
                    d="M1 1l6.22 6L1 13"
                    stroke-width="2"
                    fill="none"
                    fill-rule="evenodd"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
          <div class="calendar-body g-block">
            <div class="zb-grid zb-grid-bordered">
              <table class="zb-grid-table">
                <colgroup>
                  <col style="width: 20px; min-width: 20px;" />
                </colgroup>
                <thead class="zb-grid-thead">
                  <tr class="zb-grid-tr">
                    <th class="zb-grid-th">
                      <label
                        class="zb-checkbox-wrap"
                        :class="{
                          'zb-checkbox-checked': allChecked,
                          'zb-checkbox-indeterminate': isIndeterminate,
                        }"
                        ><span class="zb-checkbox"
                          ><span class="zb-checkbox-inner"></span
                          ><input type="checkbox" v-model="allChecked"/></span
                      ></label>
                    </th>
                    <th
                      class="zb-grid-th"
                      v-for="(item, index) in weekDays"
                      :key="item.value"
                    >
                      <div class="title">
                        <label
                          class="zb-checkbox-wrap"
                          :class="{
                            'zb-checkbox-checked': !!~weekDaysCheckbox.indexOf(
                              index
                            ),
                          }"
                          ><span class="zb-checkbox"
                            ><span class="zb-checkbox-inner"></span
                            ><input
                              type="checkbox"
                              :value="index"
                              v-model="weekDaysCheckbox"/></span></label
                        ><i>{{ item.label }}</i>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody class="zb-grid-tbody">
                  <tr
                    class="zb-grid-tr"
                    v-for="(item, index) in rows"
                    :key="index"
                  >
                    <td class="zb-grid-td">
                      <span>
                        <label
                          class="zb-checkbox-wrap"
                          :class="{
                            'zb-checkbox-checked': !!~rowCheck.indexOf(index),
                          }"
                        >
                          <span class="zb-checkbox">
                            <span class="zb-checkbox-inner"></span>
                            <input
                              type="checkbox"
                              :value="index"
                              v-model="rowCheck"
                            />
                          </span>
                        </label>
                      </span>
                    </td>
                    <td
                      class="zb-grid-td"
                      v-for="subitem in item"
                      :key="subitem.text"
                    >
                      <el-popover
                        placement="right-start"
                        width="300"
                        trigger="manual"
                        v-model="isShowOutPop[subitem.text + subitem.type]"
                        @mouseenter.native="onSchedulingMouseenter(subitem)"
                        @mouseleave.native="onSchedulingMouseleave(subitem)"
                      >
                        <div
                          class="out-scheduling-details"
                          @mouseenter="onPopMouseEnter"
                          @mouseleave="onSchedulingMouseleave(subitem)"
                        >
                          <div class="date">{{ schedulingDateText }}</div>
                          <div class="list" v-loading="isLoadingOut">
                            <template v-if="outSchedulingList.length">
                              <div
                                class="item"
                                v-for="item in outSchedulingList"
                                :key="item.id"
                              >
                                <div class="schedule-title">
                                  {{ item.schedueName }}
                                  <span
                                    >{{ item.startTime }} -
                                    {{ item.endTime }}</span
                                  >
                                </div>
                                <div class="craftsman-list">
                                  <div
                                    class="craftsman-item"
                                    v-for="man in item.workUserIds"
                                    :key="man"
                                  >
                                    <p class="nickname">
                                      {{ mapWorkUser[man].nickName }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                        <div
                          slot="reference"
                          class="management-td-wrap"
                          :class="{
                            disable: isDisable(subitem),
                          }"
                          @click="
                            !isDisable(subitem)
                              ? findSchedulingRecordInfoV2(subitem)
                              : changeMonth(
                                  subitem.type == 'next'
                                    ? 'add'
                                    : subitem.type == 'prev'
                                    ? 'reduce'
                                    : ''
                                )
                          "
                        >
                          <span class="date">{{ subitem.text }}</span>
                          <div class="count" v-if="subitem.nickNames">
                            {{ subitem.nickNames.split("、").length }}人
                          </div>
                          <div class="name-list" v-if="subitem.nickNames">
                            {{ subitem.nickNames }}
                          </div>
                          <div
                            class="checkbox"
                            v-if="!isDisable(subitem)"
                            @click.stop
                          >
                            <label
                              class="zb-checkbox-wrap"
                              :class="{
                                'zb-checkbox-checked': !!~rowsCheck.indexOf(
                                  combinationRowsValue(subitem)
                                ),
                              }"
                              ><span class="zb-checkbox"
                                ><span class="zb-checkbox-inner"></span
                                ><input
                                  type="checkbox"
                                  :value="combinationRowsValue(subitem)"
                                  v-model="rowsCheck"/></span
                            ></label>
                          </div>
                          <div
                            class="add-tips"
                            v-if="!isDisable(subitem) && !subitem.nickNames"
                          >
                            点击添加人员排班
                          </div>
                        </div>
                      </el-popover>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      class="schedule-dialog"
      :visible.sync="dialogSchedule"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
    >
      <div slot="title" class="dialog-title">
        添加排班员工
      </div>
      <div class="schedule">
        <div class="time-list">
          <span>排班日期：</span>
          <p v-popover:timeList>
            {{ schedulingDateText }}
          </p>
          <el-popover
            ref="timeList"
            placement="bottom-start"
            width="600"
            trigger="hover"
            :content="schedulingDateText"
          >
          </el-popover>
        </div>
        <template v-if="schedulingList.length">
          <div class="list">
            <div class="item" v-for="item in schedulingList" :key="item.id">
              <div class="schedule-title">
                {{ item.schedueName }}
                <span>{{ item.startTime }} - {{ item.endTime }}</span>
              </div>
              <div class="craftsman-list">
                <div
                  class="craftsman-add craftsman-item"
                  @click="showAddCraftsman(item.id)"
                >
                  <i class="el-icon-plus"></i>
                  添加员工
                </div>
                <div
                  class="craftsman-item"
                  v-for="(man, index) in item.workUserIds"
                  :key="man"
                >
                  <i
                    class="el-icon-error"
                    @click="delWorkUser(item.workUserIds, index)"
                  ></i>
                  <p class="nickname">
                    {{ mapWorkUser[man].nickName }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="action">
            <el-button type="primary" plain @click="dialogSchedule = false"
              >取消</el-button
            >
            <el-button type="primary" @click="saveSchedulingRecordForBatch"
              >确定</el-button
            >
          </div>
        </template>
        <div v-else class="list-none">
          <img src="@/assets/img/common/list-none.png" alt />
          <p>暂无班次,请前往添加</p>
          <el-button
            type="primary"
            size="small"
            @click="linkTo(`/craftsman/schedule/shiftManage`)"
            v-if="shopIsMaster"
            >前往班次管理</el-button
          >
        </div>
      </div>
      <el-dialog
        class="craftsman-select"
        width="600px"
        title="添加排班员工"
        :visible.sync="dialogCraftsmanSelect"
        append-to-body
      >
        <div class="popup-container center">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            >员工集合</el-checkbox
          >({{ currentCrasftmanList.length }}/{{ craftsmanList.length }})
          <el-input
            placeholder="输入关键字进行过滤"
            v-model="filterText"
            size="small"
            clearable
          >
          </el-input>
          <div class="checkbox-list">
            <el-checkbox-group
              v-model="currentCrasftmanList"
              @change="handleCheckedChange"
            >
              <el-checkbox
                v-for="craftsman in showCraftsmanList"
                :label="`${craftsman.workUserId}`"
                :key="craftsman.workUserId"
                >{{ craftsman.nickName }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
          <el-button type="primary" @click="confirmSelect">确定</el-button>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import {
  schedulingList,
  findSchedulingRecordList,
  findArtisans,
  findSchedulingRecordInfoV2,
  saveSchedulingRecordForBatchV2,
} from "@/api/index";
import {
  range as rangeArr,
  getFirstDayOfMonth,
  getPrevMonthLastDays,
  getMonthDays,
} from "@/utils/date-util";
import { commonFuc } from "@/mixins/commonFuc";
export default {
  mixins: [commonFuc],
  data() {
    return {
      date: new Date(new Date().pattern("yyyy-MM") + "-01"),
      currentDate: new Date(),
      isLoading: false,
      firstDayOfWeek: 0,
      WEEK_DAYS: [
        { label: "周日", value: 7 },
        { label: "周一", value: 1 },
        { label: "周二", value: 2 },
        { label: "周三", value: 3 },
        { label: "周四", value: 4 },
        { label: "周五", value: 5 },
        { label: "周六", value: 6 },
      ],
      allChecked: false,
      isIndeterminate: false,
      weekDaysCheckbox: [],
      rowCheck: [],
      rowsCheck: [],
      dialogSchedule: false,
      schedulingDate: "",
      schedulingDateText: "",
      schedulingList: [],
      scheduleId: "",
      mapWorkUser: {},
      workUserId: "",
      nickName: "",
      dialogCraftsmanSelect: false,
      baseCrasftmanList: [],
      isIndeterminate: false,
      checkAll: false,
      craftsmanList: [],
      filterText: "",
      currentCrasftmanList: [],
      outSchedulingList: [],
      mapOutScheduling: {},
      isShowOutPop: {},
      isLoadingOut: false,
      getOutDetailsTimer: null,
      hideTimer: null,
    };
  },
  computed: {
    weekDays() {
      const start = this.firstDayOfWeek;
      const { WEEK_DAYS } = this;

      if (typeof start !== "number" || start === 0) {
        return WEEK_DAYS.slice();
      } else {
        return WEEK_DAYS.slice(start).concat(WEEK_DAYS.slice(0, start));
      }
    },
    rows() {
      let days = [];
      const date = this.date;
      let firstDay = getFirstDayOfMonth(date);
      firstDay = firstDay === 0 ? 7 : firstDay;
      const firstDayOfWeek =
        typeof this.firstDayOfWeek === "number" ? this.firstDayOfWeek : 1;
      const prevMonthDays = getPrevMonthLastDays(
        date,
        firstDay - firstDayOfWeek
      ).map((day) => ({
        text: day,
        type: "prev",
      }));
      const currentMonthDays = getMonthDays(date).map((day) => ({
        text: day,
        type: "current",
        nickNames: "",
      }));
      if (prevMonthDays.length == 7) {
        days = [...currentMonthDays];
      } else {
        days = [...prevMonthDays, ...currentMonthDays];
      }
      let baseDays = 35;
      if (days.length > baseDays) {
        baseDays = 42;
      }
      const nextMonthDays = rangeArr(baseDays - days.length).map(
        (_, index) => ({
          text: index + 1,
          type: "next",
        })
      );
      days = days.concat(nextMonthDays);
      return this.toNestedArr(days);
    },
    showCraftsmanList() {
      return this.craftsmanList.filter((val) => {
        return val.nickName.indexOf(this.filterText) !== -1;
      });
    },
  },
  watch: {
    weekDaysCheckbox(val, oldVal) {
      let difArr = this.getArrDifference(val, oldVal);
      if (val.length > oldVal.length) {
        difArr.forEach((subval) => {
          this.rows.forEach((row) => {
            if (
              !this.isDisable(row[subval]) &&
              this.rowsCheck.indexOf(this.combinationRowsValue(row[subval])) ==
                -1
            ) {
              this.rowsCheck.push(this.combinationRowsValue(row[subval]));
            }
          });
        });
      } else {
        difArr.forEach((subval) => {
          this.rows.forEach((row) => {
            if (!this.isDisable(row[subval])) {
              this.rowsCheck.splice(
                this.rowsCheck.indexOf(this.combinationRowsValue(row[subval])),
                1
              );
            }
          });
        });
      }
    },
    rowCheck(val, oldVal) {
      let difArr = this.getArrDifference(val, oldVal);
      if (this.rows.length == val.length) {
        this.allChecked = true;
        this.isIndeterminate = false;
      } else {
        console.log(this.getArrDifference(val, oldVal));
        if (val.length > oldVal.length) {
          difArr.forEach((subval) => {
            this.rows[subval].forEach((subitem) => {
              if (
                !this.isDisable(subitem) &&
                this.rowsCheck.indexOf(this.combinationRowsValue(subitem)) == -1
              ) {
                this.rowsCheck.push(this.combinationRowsValue(subitem));
              }
            });
          });
        } else {
          difArr.forEach((subval) => {
            this.rows[subval].forEach((subitem) => {
              if (!this.isDisable(subitem)) {
                console.log(subitem);
                this.rowsCheck.splice(
                  this.rowsCheck.indexOf(this.combinationRowsValue(subitem)),
                  1
                );
              }
            });
          });
        }
        if (!val.length) {
          if (!this.rowsCheck.length) {
            this.weekDaysCheckbox = [];
          }
          this.allChecked = false;
          this.isIndeterminate = false;
        } else {
          this.isIndeterminate = true;
        }
        if (this.allChecked) {
          this.allChecked = false;
          this.isIndeterminate = true;
        }
      }
    },
    allChecked(val) {
      if (val) {
        this.rowCheck = [];
        this.rows.forEach((val, index) => {
          this.rowCheck.push(index);
        });
        this.weekDaysCheckbox = [];
        this.weekDays.forEach((val, index) => {
          this.weekDaysCheckbox.push(index);
        });
      } else {
        if (!this.isIndeterminate) {
          this.rowCheck = [];
          this.weekDaysCheckbox = [];
        }
      }
    },
    rowsCheck(val) {
      let weekCanList = {};
      let rowCanList = {};
      this.rows.forEach((row, rowIndex) => {
        row.forEach((item, index) => {
          if (!this.isDisable(item)) {
            if (!rowCanList[rowIndex]) {
              rowCanList[rowIndex] = 1;
            } else {
              rowCanList[rowIndex]++;
            }
            if (!weekCanList[index]) {
              weekCanList[index] = 1;
            } else {
              weekCanList[index]++;
            }
          }
        });
      });
      this.rows.forEach((row, rowIndex) => {
        row.forEach((item, index) => {
          if (val.indexOf(this.combinationRowsValue(item)) != -1) {
            weekCanList[index]--;
            rowCanList[rowIndex]--;
          }
        });
      });
      Object.keys(weekCanList).forEach((weekVal) => {
        let week = Number(weekVal);
        let isHav = this.weekDaysCheckbox.indexOf(week) != -1;
        if (!weekCanList[week]) {
          if (!isHav) {
            this.weekDaysCheckbox.push(week);
          }
        } else {
          if (isHav) {
            this.weekDaysCheckbox.splice(
              this.weekDaysCheckbox.indexOf(week),
              1
            );
          }
        }
      });
      Object.keys(rowCanList).forEach((rowVal) => {
        let row = Number(rowVal);
        let isHav = this.rowCheck.indexOf(row) != -1;
        if (!rowCanList[row]) {
          if (!isHav) {
            this.rowCheck.push(row);
          }
        } else {
          if (isHav) {
            this.rowCheck.splice(this.rowCheck.indexOf(row), 1);
          }
        }
      });
      console.log(val);
    },
    dialogSchedule(val) {
      if (!val) {
        this.schedulingDate = "";
        this.schedulingDateText = "";
      }
    },
    dialogCraftsmanSelect(val) {
      if (!val) {
        this.resetCrasftmanSelect();
      }
    },
    date() {
      this.findArtisans();
    },
    workUserId() {
      this.findSchedulingRecordList();
    },
  },
  mounted() {
    this.getSchedulingList();
    this.findArtisans();
  },
  methods: {
    handleCheckAllChange(val) {
      let options = [];
      this.showCraftsmanList.forEach((val) => {
        options.push(String(val.workUserId));
      });
      this.currentCrasftmanList = val ? options : [];
      this.isIndeterminate = false;
    },
    handleCheckedChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.craftsmanList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.craftsmanList.length;
    },
    toNestedArr(days) {
      return rangeArr(days.length / 7).map((_, index) => {
        const start = index * 7;
        return days.slice(start, start + 7);
      });
    },
    isDisable(item) {
      return (
        item.type != "current" ||
        ((Number(item.text) < Number(new Date().getDate()) &&
          this.date.getMonth() == new Date().getMonth() &&
          this.date.getFullYear() == new Date().getFullYear()) ||
          (this.date.getMonth() < new Date().getMonth() &&
            this.date.getFullYear() == new Date().getFullYear()) ||
          this.date.getFullYear() < new Date().getFullYear())
      );
    },
    combinationRowsValue(value) {
      return value.text + ":" + value.type;
    },
    getArrDifference(arr1, arr2) {
      return arr1.concat(arr2).filter((v, i, arr) => {
        return arr.indexOf(v) === arr.lastIndexOf(v);
      });
    },
    changeMonth(type) {
      if (!type) {
        this.$notify.error("无法编辑过去的排班");
        return;
      } else {
        this.allChecked = false;
        this.weekDaysCheckbox = [];
        this.rowCheck = [];
        this.rowsCheck = [];
      }
      let date = this.date;
      if (type == "add") {
        date.setMonth(date.getMonth() + 1);
      }
      if (type == "reduce") {
        date.setMonth(date.getMonth() - 1);
      }
      this.date = new Date(date);
    },
    getSchedulingList() {
      schedulingList({ row: 9999 }).then((res) => {
        if (res.code == 1) {
          this.schedulingList = res.data;
        }
      });
    },
    findSchedulingRecordInfoV2(item) {
      this.schedulingList.forEach((val) => {
        val.workUserIds = "";
      });
      let date = new Date(this.date.pattern("yyyy-MM-") + item.text);
      this.schedulingDateText = `${date.pattern("yyyy")}年${date.pattern(
        "MM"
      )}月${date.pattern("dd")}日`;
      this.schedulingDate = date.pattern("yyyy-MM-dd");
      // if (!item.nickNames) {
      //   this.dialogSchedule = true;
      //   return;
      // }
      console.log(this.date.pattern("yyyy-MM-") + item.text);
      findSchedulingRecordInfoV2({
        schedulingDate: date.pattern("yyyy-MM-dd"),
      }).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.schedulingList.forEach((val) => {
            res.data.forEach((current) => {
              if (val.id == current.schedulingId) {
                val.workUserIds = current.workUserIds.split(",");
              }
            });
          });
        }
        this.dialogSchedule = true;
      });
    },
    findSchedulingRecordList() {
      this.weekDaysCheckbox = [];
      this.rowCheck = [];
      this.rowsCheck = [];
      this.rows.forEach((row) => {
        row.forEach((subrow) => {
          subrow.nickNames = "";
          subrow.workUserIds = [];
        });
      });
      this.$forceUpdate();
      findSchedulingRecordList({
        schedulingDate: this.date.pattern("yyyy-MM-dd"),
        workUserId: this.workUserId,
        nickName: this.nickName,
      }).then((res) => {
        if (res.code == 1) {
          res.data.forEach((val, index) => {
            if (val.workUserIds) {
              let workUserIds = val.workUserIds.split(",");
              this.rows[parseInt(index / 7)][
                index % 7
              ].nickNames = this.formatWorkUser(workUserIds);
              this.rows[parseInt(index / 7)][
                index % 7
              ].workUserIds = workUserIds;
            }
          });
          this.$forceUpdate();
        }
        this.isLoading = false;
      });
    },
    findArtisans() {
      this.isLoading = true;
      findArtisans({ row: 9999 }).then((res) => {
        if (res.code == 1) {
          this.baseCrasftmanList = res.data;
          this.baseCrasftmanList.unshift({
            workUserId: "",
            nickName: "所有手艺人",
          });
          res.data.forEach((val) => {
            this.mapWorkUser[val.workUserId] = val;
          });
        }
        this.findSchedulingRecordList();
      });
    },
    formatWorkUser(workUserIds) {
      let nickNames = "";
      workUserIds.forEach((val) => {
        if (nickNames) {
          nickNames += `、${this.mapWorkUser[val].nickName}`;
        } else {
          nickNames = this.mapWorkUser[val].nickName;
        }
      });
      return nickNames;
    },
    showAddCraftsman(id) {
      this.scheduleId = id;
      let isCheckedArr = [];
      this.schedulingList.forEach((val) => {
        isCheckedArr.push(...val.workUserIds);
      });
      console.log(isCheckedArr);
      this.craftsmanList = this.baseCrasftmanList.filter((val) => {
        return (
          val.workUserId && isCheckedArr.indexOf(String(val.workUserId)) == -1
        );
      });
      console.log(this.craftsmanList);
      this.dialogCraftsmanSelect = true;
    },
    confirmSelect() {
      this.schedulingList.forEach((val) => {
        if (val.id == this.scheduleId) {
          if (val.workUserIds.length) {
            val.workUserIds = val.workUserIds.concat(
              ...this.currentCrasftmanList
            );
          } else {
            val.workUserIds = this.currentCrasftmanList;
          }
        }
      });
      this.resetCrasftmanSelect();
      this.dialogCraftsmanSelect = false;
    },
    resetCrasftmanSelect() {
      this.currentCrasftmanList = [];
      this.isIndeterminate = false;
      this.checkAll = false;
    },
    saveSchedulingRecordForBatch() {
      let params = [];
      let schedulingDate = this.schedulingDate.split("");
      if (schedulingDate[0] == ",") {
        schedulingDate.splice(0, 1);
      }
      if (schedulingDate[schedulingDate.length - 1] == ",") {
        schedulingDate.splice(schedulingDate.length - 1, 1);
      }
      this.schedulingList.forEach((val) => {
        params.push({
          schedulingId: Number(val.id),
          workUserIds: val.workUserIds.length ? val.workUserIds.join(",") : "",
          schedulingDates: schedulingDate.join(""),
        });
      });
      saveSchedulingRecordForBatchV2({
        batchJsonStr: JSON.stringify(params),
      }).then((res) => {
        if (res.code == 1) {
          this.$notify.success("保存成功");
          this.findArtisans();
          this.dialogSchedule = false;
        } else {
          this.$notify.error(res.msg);
        }
      });
    },
    delWorkUser(list, index) {
      list.splice(index, 1);
      console.log(list);
      this.$forceUpdate();
    },
    batchEdit() {
      this.schedulingDateText = "";
      if (!this.rowsCheck.length) {
        return this.$message.error("请先选择日期");
      }
      if (this.rowsCheck.length == 1) {
        let item = {};
        this.rows.forEach((row) => {
          row.forEach((subrow) => {
            if (
              subrow.text == this.rowsCheck[0].split(":")[0] &&
              subrow.type == "current"
            ) {
              item = subrow;
            }
          });
        });
        this.findSchedulingRecordInfoV2(item);
        return;
      }
      this.schedulingList.forEach((val) => {
        val.workUserIds = "";
      });
      this.rowsCheck.forEach((row) => {
        let text = row.split(":")[0];
        // this.data = this.data.replace(/\-/g, "/");
        let date = new Date(
          this.date.pattern("yyyy-MM-") + (text.length == 1 ? "0" + text : text)
        );
        console.log(date, this.date);
        if (!this.schedulingDateText) {
          this.schedulingDateText = `${date.pattern("yyyy")}年${date.pattern(
            "MM"
          )}月${date.pattern("dd")}日`;
          this.schedulingDate = date.pattern("yyyy-MM-dd");
        } else {
          this.schedulingDateText += `、${date.pattern("yyyy")}年${date.pattern(
            "MM"
          )}月${date.pattern("dd")}日`;
          this.schedulingDate += `,${date.pattern("yyyy-MM-dd")}`;
        }
      });
      console.log(this.schedulingDate);
      this.dialogSchedule = true;
    },
    onSchedulingMouseenter(item) {
      if (!item.workUserIds.length) return;
      let date = new Date(this.date.pattern("yyyy-MM-") + item.text);
      for (let val in this.isShowOutPop) {
        this.isShowOutPop[val] = false;
      }
      console.log(">>>this.mapOutScheduling", this.mapOutScheduling);
      // if (this.mapOutScheduling[+date]) {
      //   this.outSchedulingList = this.mapOutScheduling[+date];
      //   this.schedulingDateText = `${date.pattern("yyyy")}年${date.pattern(
      //     "MM"
      //   )}月${date.pattern("dd")}日`;
      //   this.isShowOutPop[item.text + item.type] = true;
      //   return;
      // } else {
      clearTimeout(this.getOutDetailsTimer);
      this.getOutDetailsTimer = setTimeout(() => {
        this.outSchedulingList = [];
        this.schedulingDateText = `${date.pattern("yyyy")}年${date.pattern(
          "MM"
        )}月${date.pattern("dd")}日`;
        this.isShowOutPop[item.text + item.type] = true;
        this.isLoadingOut = true;
        findSchedulingRecordInfoV2({
          schedulingDate: date.pattern("yyyy-MM-dd"),
        }).then((res) => {
          if (res.code == 1) {
            this.schedulingList.forEach((val) => {
              res.data.forEach((current) => {
                if (
                  val.id == current.schedulingId &&
                  (current.workUserIds.indexOf(this.workUserId) != -1 ||
                    current.nickNames.indexOf(this.nickName) != -1)
                ) {
                  val.workUserIds = current.workUserIds
                    .split(",")
                    .filter((v) => {
                      return item.workUserIds.indexOf(v) != -1;
                    });
                  if (val.workUserIds.length) {
                    this.outSchedulingList.push(val);
                  }
                }
              });
            });
            console.log(+date, this.outSchedulingList);
            this.mapOutScheduling[+date] = this.outSchedulingList;
          }
          this.isLoadingOut = false;
        });
      }, 5e2);
      // }
    },
    onSchedulingMouseleave(item) {
      clearTimeout(this.getOutDetailsTimer);
      this.hideTimer = setTimeout(() => {
        this.isShowOutPop[item.text + item.type] = false;
      }, 5e2);
    },
    onPopMouseEnter() {
      console.log("onPopMouseEnter");
      clearTimeout(this.hideTimer);
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-content {
    display: block;
    padding: 20px;
  }
  .header-right {
    .el-select {
      width: 200px;
    }
  }
  .calendar {
    .zb-checkbox-indeterminate {
      .zb-checkbox {
        .zb-checkbox-inner {
          border-color: var(--c_main, #409eff);
          background: #fff;
          &:after {
            top: 6px;
            left: 2px;
            width: 10px;
            height: 2px;
            border: 0;
            background: var(--c_main, #409eff);
            transform: rotate(0deg);
          }
        }
      }
    }
    .zb-checkbox-checked {
      .zb-checkbox {
        .zb-checkbox-inner {
          border-color: var(--c_main, #409eff);
          background: var(--c_main, #409eff);
          &:after {
            background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAABGdBTUEAALGPC/xhBQAAASxJREFUOBGlkr9LQlEUx01Di1pCCKQhkAZxaMs/oFnwD3Bwqcmh0cnB0ak5HBwdHNyT5sDFIUIQxMXBQWgIIjB7fa7c+zjvvnfR9MCH8+t7vtOJxfYMz/OyMIIniB/u44dBhvs+ZCEHX7BbYHYGbyBjtpMbDifwKp2ol1D8tyFHSXgGGb805YAZg+PAIKJBE4cu2FH15WyOoA8fUPAXEQX7FthRD0jZdoRiQZ0PCHTDvCl0pnwMadlMzFbnGflSCulrlka1bTiQunXN8AY+QcaY5lwJyPdyoeseOREyMwOWt/CtxSYNKe5gZQY6v5BT5taZEZXgRx+50oDFqdPEXiCugPqpqHhnmLZvNvYcPUS4TZldbDx2CThuCNM59ZVLu/UcE/V36qWutz5C+AfE+OIwPOZePgAAAABJRU5ErkJggg==);
            transform: scale(1);
          }
        }
      }
    }
    .zb-checkbox-wrap {
      cursor: pointer;
      font-weight: 400;
      margin: 0;
      padding: 0;
      margin-right: 15px;
      vertical-align: middle;
      &:last-child {
        margin-right: 0;
      }
    }
    .zb-checkbox {
      position: relative;
      display: inline-block;
      width: 16px;
      height: 16px;
      white-space: nowrap;
      outline: none;
      vertical-align: middle;
      line-height: 1;
      margin: 0;
      padding: 0;
      & > input {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        opacity: 0;
        cursor: pointer;
        box-sizing: border-box;
      }
    }
    .zb-checkbox-inner {
      position: relative;
      top: 0;
      left: 0;
      display: inline-block;
      width: 16px;
      height: 16px;
      border-radius: 2px;
      border: 1px solid #c8c9cc;
      background: #fff;
      box-sizing: border-box;
      transition: all 0.3s;
      &:after {
        box-sizing: content-box;
        position: absolute;
        display: block;
        content: " ";
        font-size: 0;
        top: 3px;
        left: 2px;
        width: 10px;
        height: 8px;
        background-size: contain;
        transform: scale(0);
        transition: all 0.12s ease-in-out;
      }
    }
    .calendar-header {
      position: relative;
      padding: 10px 0;
      .grid-btn {
        color: #409eff;
        border-color: #409eff;
      }
      .date-ctrl {
        display: flex;
        position: absolute;
        justify-content: center;
        align-items: center;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        user-select: none;
        .date {
          font-size: 24px;
          color: #323233;
          width: 140px;
          text-align: center;
          line-height: 21px;
        }
        .arrow {
          position: relative;
          width: 16px;
          height: 20px;
          padding: 0 20px;
          cursor: pointer;
          display: flex;
          align-items: center;
          .zb-pagination-arrow {
            stroke: #323233;
          }
          &.disable {
            cursor: no-drop;
            .zb-pagination-arrow {
              stroke: #c8c9cc;
            }
          }
        }
      }
    }
    .calendar-body {
      .zb-grid {
        font-size: 14px;
        color: #323233;
        position: relative;
        line-height: 1.5;
        overflow: hidden;
        &.zb-grid-bordered {
          td,
          th {
            box-shadow: inset 1px -1px 0 0 #ebedf0;
          }
          tr:first-of-type {
            th:first-of-type {
              box-shadow: none;
            }
          }
        }
      }
      .title {
        margin-left: -8px;
        & > i {
          font: inherit;
          display: inline-block;
          transform: translateY(3px);
        }
      }
      .zb-grid-table {
        border-right: 1px solid #ebedf0;
        border-top: 1px solid #ebedf0;
        width: 100%;
        text-align: left;
        border-collapse: collapse;
        border-spacing: 0;
      }
      .zb-grid-td {
        position: relative;
        height: 84px;
        line-height: 20px;
        padding: 8px 16px;
        font-size: 14px;
        display: table-cell;
        box-sizing: border-box;
        vertical-align: middle;
        .zb-checkbox-wrap {
          transform: translateY(-28px);
        }
      }
      .zb-grid-tr {
        display: table-row;
        height: 56px;
        background-color: #fff;
        &:hover {
          background: #fff;
        }
        .zb-grid-th {
          line-height: 20px;
          padding: 18px 16px;
          font-weight: 500;
          background-color: #f7f8fa;
          font-size: 14px;
          box-sizing: border-box;
          display: table-cell;
          vertical-align: middle;
        }
      }
      .management-td-wrap {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        cursor: pointer;
        & > .checkbox {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          z-index: 10;
          .zb-checkbox-wrap {
            padding: 4px 0 8px 8px;
            width: 100%;
            height: 29px;
            box-sizing: border-box;
            transform: translateY(0);
          }
        }
        &:hover {
          background: #ecf5ff;
          .add-tips {
            display: block;
          }
        }
        &.disable {
          opacity: 0.4;
          background: none;
          :after {
            content: "";
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            z-index: 10;
          }
        }
        .add-tips {
          position: absolute;
          bottom: 7px;
          left: 8px;
          font-size: 14px;
          color: #409eff;
        }
        .date {
          display: block;
          height: 100%;
          color: #409eff;
          opacity: 0.2;
          font-size: 40px;
          line-height: 84px;
          text-align: center;
        }
        & > .checkbox {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          z-index: 10;
          .zb-checkbox-wrap {
            display: block;
            padding: 4px 0 8px 8px;
            width: 100%;
            height: 29px;
            box-sizing: border-box;
            transform: translateY(0);
          }
        }
        .count {
          position: absolute;
          right: 8px;
          top: 8px;
          color: #409eff;
          font-size: 14px;
        }
        .name-list {
          position: absolute;
          width: calc(100% - 1px);
          height: 24px;
          bottom: 0;
          left: 1px;
          box-sizing: border-box;
          background: #409eff;
          color: #fff;
          padding: 0 8px;
          line-height: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .schedule-calendar-pop {
        transform: translateY(40px);
      }
    }
  }
}
.schedule-dialog {
  .list-none {
    text-align: center;
    font-size: 14px;
    color: #999999;
    padding: 200px;
    & > p {
      margin: 10px 0;
    }
  }
  .schedule {
    .time-list {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      span {
        font-size: 14px;
        opacity: 0.5;
      }
      p {
        flex: 1;
        font-size: 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .list {
      height: 500px;
      overflow-y: scroll;
      .item {
        .schedule-title {
          line-height: 52px;
          font-size: 12px;
          background: #f7f8fa;
          margin-bottom: 16px;
          padding: 0 16px;
          box-sizing: border-box;
          span {
            opacity: 0.5;
            margin-left: 6px;
          }
        }
        .craftsman-list {
          display: flex;
          flex-wrap: wrap;
          .craftsman-item {
            position: relative;
            background: #f5f5f5;
            border-radius: 4px;
            font-size: 14px;
            padding: 8px;
            width: calc(16.66667% - 8px);
            margin-bottom: 12px;
            margin-right: 8px;
            height: 57px;
            color: #323233;
            box-sizing: border-box;
            &:nth-of-type(6n) {
              margin-right: 0;
            }
            .nickname {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .el-icon-error {
              font-size: 20px;
              position: absolute;
              right: -5px;
              top: -5px;
              cursor: pointer;
            }
          }
          .craftsman-add {
            font-size: 12px;
            border: 1px dashed rgba(50, 50, 51, 0.15);
            border-radius: 2px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #ffffff;
            cursor: pointer;
            i {
              margin-right: 5px;
            }
          }
        }
      }
    }
    .action {
      text-align: center;
      padding: 15px 0;
    }
  }
}
.popup-container {
  height: 500px;
  .el-input {
    margin: 10px 0;
  }
  .checkbox-list {
    height: calc(100% - 150px);
    .el-checkbox {
      display: block;
      margin-bottom: 10px;
    }
  }
  .el-button {
    float: right;
  }
}
.out-scheduling-details {
  .date {
    padding: 10px;
    border-bottom: 0.5px solid #ccc;
  }
  .list {
    min-height: 100px;
    max-height: 300px;
    overflow: auto;
    .item {
      .schedule-title {
        position: relative;
        font-size: 12px;
        line-height: 30px;
        padding-left: 10px;
        box-sizing: border-box;
        span {
          opacity: 0.5;
          margin-left: 6px;
        }
        &::before {
          content: "";
          display: block;
          position: absolute;
          top: 8px;
          bottom: 8px;
          left: 0;
          width: 2px;
          border-radius: 2px;
          background: #409eff;
        }
      }
      .craftsman-list {
        display: flex;
        flex-wrap: wrap;
        .craftsman-item {
          width: 50%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          padding-left: 10px;
          box-sizing: border-box;
          font-size: 12px;
          line-height: 30px;
        }
      }
    }
  }
}
</style>
